module.exports = ".odd{\r\n    background-color: rgba(0,0,0,.05)\r\n}\r\n\r\n.even{\r\n    background-color: #FFFFFF\r\n}\r\n\r\n.bg-disable{\r\n    background-color: rgba(0,0,0,.1)\r\n}\r\n\r\n.description{\r\n    word-break: break-all;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/b0001-home/b0001-home.component.css
// module id = ./src/app/b0001-home/b0001-home.component.css
// module chunks = main